import React from 'react';
import ReactDOM from 'react-dom/client';
import StyleIQ from './StyleIQ';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleIQ />
  </React.StrictMode>
);
